import React, { Component } from 'react';
import { connect } from 'react-redux';

class ViewExportAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
closeAlert = () => {
  this.props.updateCanViewExportAlert(false);
}
linkToPricingPage = () => {
  this.props.history.push({ pathname: '/pricing' });
}
  render() {
      return (
        <div className="alert-container fade-in">
  				<div className="row d-flex justify-content-center">
  					<div className="col-sm-10 col-md-7 text-center">
  						<div
  							className="alert alert-info alert-onboarding"
  							role="alert"
  							data-color="info"
  							onClick={() => this.closeAlert()}>
  							<div className="d-flex justify-content-between">
  								<span className="alert-copy">
  								  Please <u onClick={() => this.linkToPricingPage()}>upgrade</u> to export results
  								</span>
  								<i className="fas fa-times fa-sm alert-close"></i>
  							</div>
  						</div>
  					</div>
  				</div>
  			</div>
      );
    }
}
const mapStateToProps = state => {
    return {};
};

const mapDispatchToProps = dispatch => {
  return {
        updateCanViewExportAlert: (canViewExportAlert) => dispatch({ type: 'CAN_VIEW_EXPORT_ALERT', value: canViewExportAlert })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewExportAlert);
